import { render, staticRenderFns } from "./NextButton.vue?vue&type=template&id=716f4b98&scoped=true&"
import script from "./NextButton.vue?vue&type=script&lang=js&"
export * from "./NextButton.vue?vue&type=script&lang=js&"
import style0 from "./NextButton.vue?vue&type=style&index=0&id=716f4b98&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "716f4b98",
  null
  
)

export default component.exports